import React from 'react'
import { getTermHeader } from '../../../domain/term/headerMappings/getTermHeader'
import { CustomHeaderType } from '../../../domain/term/headerMappings/constants'
import CenterCarousel from './CenterCarousel'

export default function CenterCarouselTermHeader({
  termAttr,
  termValue,
  title,
  isLoading,
  centers,
  shouldDefaultRegionalize = false,
  withGradient,
  customTermHeader,
  zoneId,
  containerId
}) {
  const featuredCenterHeader = getTermHeader({
    pageType: termAttr,
    title: title || termValue,
    termTitle: termValue,
    customTermHeader,
    headerType: CustomHeaderType.FEATURED_CENTERS
  })

  return (
    <CenterCarousel
      centers={centers}
      shouldDefaultRegionalize={shouldDefaultRegionalize}
      sectionHeading={featuredCenterHeader}
      withGradient={withGradient}
      isLoading={isLoading}
      zoneId={zoneId}
      containerId={containerId}
      termTitle={termValue}
    />
  )
}
